// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectWidget_container__1MLyY","selected":"SelectWidget_selected__NSEp5"};